// Form.js
import React, { useState } from 'react';
import { Container, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Typography, Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ModalAlert from './modal';

import similar from './image/sel.jpg';


const Form = () => {

const [modalOpen, setModalOpen] = useState(false);
const [modalMessage, setModalMessage] = useState('');

const showAlert = (message) => {
  setModalMessage(message);
  setModalOpen(true);
};

const handleClose = () => {
  setModalOpen(false);
  setModalMessage('');
};


  const navigate = useNavigate();

  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
      // setPhoto(file);
      console.log('File type:', file.type);

      handleUpload(file);

      if (file) {
        resizeImage(file, 800, 800, 0.7);
      }

    // 파일 처리 로직...
  };


const handleUpload = async (file) => {

    setLoading(true); // 로딩 시작

    const formData = new FormData();
    formData.append("file", file);
    console.log("업로드",file);

    try {
      const response = await fetch("http://221.162.142.163:8080/findWeb", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {

        console.log(response);

      } else {
        alert("분석에 실패하였습니다. 다른 사진을 등록해주세요.");
      }
    } catch (error) {
      console.log("업로드 오류:", error);
      console.error("업로드 오류:", error);
      alert("분석에 실패하였습니다. 다른 사진을 등록해주세요.");
    } finally {
      setLoading(false); // 로딩 종료
    }

};


  const resizeImage = (file, maxWidth, maxHeight, quality) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {

        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {

          console.log("img");

          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // 비율을 유지하면서 크기 조정
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // 압축된 이미지 URL 생성
          canvas.toBlob((blob) => {
            const newFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });

            console.log(newFile);
            // setPhoto(newFile);

            const previewUrl = URL.createObjectURL(newFile);
            setPreviewUrl(previewUrl);
          }, file.type, quality); // 품질 설정
        };

        img.onerror = (err) => {
          showAlert('이미지 파일 형식을 변경해주세요.');
              // console.error('이미지 로드 실패:', err);
        };

      };

    }



  return (
    <Container component="main" maxWidth="xs" sx={{ mt: 4, justifyContent: 'center'}}>
      <div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center', // 수직 중앙 정렬
              justifyContent: 'center', // 수평 중앙 정렬
            }}
          >

          <Typography variant="h7" gutterBottom>
            얼굴 사진을 업로드 해주세요.
          </Typography>

          <Typography variant="h7" gutterBottom sx={{ mb: 2}}>
            * 사진은 시스템에 저장되지 않습니다.
          </Typography>

          <img src={previewUrl ? previewUrl : similar} alt="preview"

          style={{ width: '250px', height: '250px' }}
          sx={{mt:10, mb: 10, display: 'flex', justifyContent: 'center'}}
          />

              <Button
                variant="contained"
                component="label"
                fullWidth
                sx={{height:'40px',mt:4,mb:6, width: '300px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
              >
                {loading ? "분석 중..." : "사진 업로드"}
                <input
                  type="file" accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </Button>

              <iframe src="https://ads-partners.coupang.com/widgets.html?id=924001&template=carousel&trackingCode=AF2661812&subId=&width=200&height=200&tsource=" width="200" height="200" frameborder="0" scrolling="no" referrerpolicy="unsafe-url" browsingtopics></iframe>

            </Box>




      </div>




    </Container>
  );
};

export default Form;
